const initialState = {
  isCartModalOpen: false,
};

const CartReducer = (state = initialState, action) => {
  switch (action.type) {
    case "Set_Cart_Modal_Open":
      return {
        ...state,
        isCartModalOpen: action.payload,
      };

    default:
      return state;
  }
};

export default CartReducer;